import React from "react";
import { Modal } from "react-bootstrap";
import { HeaderTemplate } from "./headerTemplate";
import { BodyTemplate } from "./bodyTemplate";
import { FooterTemplate } from "./footerTemplate";
import { DownloadExcelReport } from "../downloadMisComponent";

export function ModalTemplate({
  headerDisplay = true, // default visibility
  footerDisplay = true, // default visibility
  bodyDisplay = true, // default visibility
  isCustom = false,
  customSection = null,
  headerTemplate = null,
  bodyTemplate = null,
  footerTemplate = null,
  headerTitle = "",
  bodyContent = "",
  onClose = () => {},
  onCloseTitle = "Close",
  onSubmit = () => {},
  onSubmitTitle = "",
  submitDisable = "",
  loadingPercent = 0,
  modalFooterHide,
  closeButton = true,
  isImageUpLoading,
  isReview = false,
  newsLetter = false,
  uploadStatus,
  loadingNewsLetter = false
}) {
  console.log(isCustom, customSection);
  return (
    <React.Fragment>
      {headerDisplay ? (
        <Modal.Header closeButton={closeButton}>
          {headerTemplate
            ? headerTemplate
            : <HeaderTemplate title={headerTitle} onClose={onClose} /> || (
                <React.Fragment />
              )}
        </Modal.Header>
      ) : (
        <React.Fragment />
      )}
      <Modal.Body>
        {bodyTemplate
          ? bodyTemplate
          : <BodyTemplate content={bodyContent} /> || <React.Fragment />}
      </Modal.Body>
      {isCustom && customSection}

      {footerDisplay && loadingPercent === 0 ? (
        <Modal.Footer
          style={{
            display:
              modalFooterHide ||
              (isReview && isImageUpLoading == "LOADING") ||
              loadingNewsLetter
                ? "none"
                : null
          }}
        >
          {footerTemplate ? (
            <React.Fragment>
              {footerTemplate}
              <FooterTemplate
                closeTitle={onCloseTitle}
                submitTitle={onSubmitTitle}
                onSubmit={onSubmit}
                onClose={onClose}
                submitDisable={submitDisable}
              />
            </React.Fragment>
          ) : (
            (
              <FooterTemplate
                closeTitle={onCloseTitle}
                submitTitle={onSubmitTitle}
                onSubmit={onSubmit}
                onClose={onClose}
                submitDisable={submitDisable}
              />
            ) || <React.Fragment />
          )}
        </Modal.Footer>
      ) : (
        <React.Fragment />
      )}
    </React.Fragment>
  );
}
